import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mantine/core';
import { getCommonCellStyles } from '../column.utils';
export const MRT_TableFooterCell = ({ footer, table, }) => {
    var _a, _b, _c;
    const { options: { layoutMode, mantineTableFooterCellProps }, } = table;
    const { column } = footer;
    const { columnDef } = column;
    const { columnDefType } = columnDef;
    const mTableFooterCellProps = mantineTableFooterCellProps instanceof Function
        ? mantineTableFooterCellProps({ column, table })
        : mantineTableFooterCellProps;
    const mcTableFooterCellProps = columnDef.mantineTableFooterCellProps instanceof Function
        ? columnDef.mantineTableFooterCellProps({ column, table })
        : columnDef.mantineTableFooterCellProps;
    const tableCellProps = Object.assign(Object.assign({}, mTableFooterCellProps), mcTableFooterCellProps);
    return (_jsx(Box, Object.assign({ component: "th", align: columnDefType === 'group' ? 'center' : 'left', colSpan: footer.colSpan }, tableCellProps, { sx: (theme) => (Object.assign({ display: layoutMode === 'grid' ? 'grid' : 'table-cell', fontWeight: 'bold', justifyContent: columnDefType === 'group' ? 'center' : undefined, padding: '8px', verticalAlign: 'top', zIndex: column.getIsPinned() && columnDefType !== 'group' ? 2 : 1 }, getCommonCellStyles({
            column,
            table,
            theme,
            tableCellProps,
        }))), children: _jsx(_Fragment, { children: footer.isPlaceholder
                ? null
                : (_c = (_b = (columnDef.Footer instanceof Function
                    ? (_a = columnDef.Footer) === null || _a === void 0 ? void 0 : _a.call(columnDef, {
                        column,
                        footer,
                        table,
                    })
                    : columnDef.Footer)) !== null && _b !== void 0 ? _b : columnDef.footer) !== null && _c !== void 0 ? _c : null }) })));
};
//# sourceMappingURL=MRT_TableFooterCell.js.map